<template>
  <el-main class="main-con el-main">
    <router-view />
  </el-main>
</template>

<script>
    export default {
        name: "FangReporting"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FangReporting.vue